import axios, { handleErrorResponse, redirectToErrorPage } from './axios-config';
import {
	IApiErrorResponse,
	ICustomerCheckResponse,
	ICustomerCreateResponse,
	ICustomerRequest,
	Locales,
} from '../models';
import { addAuthorizationHeader, addTrackingHeader, buildApiEndpoint, getRequestBody } from '../helper-fns/apiHelper';

export const CustomerService = {
	create: async (body: ICustomerRequest): Promise<ICustomerCreateResponse> =>
		await axios
			.post(buildApiEndpoint(`/customer/create`), body, addTrackingHeader())
			.then(({ data }) => data)
			.catch((res: IApiErrorResponse) => handleErrorResponse(res)),
	update: async (body: ICustomerRequest, token: string) => {
		const config = addAuthorizationHeader(token);
		return await axios
			.post(buildApiEndpoint(`/customer/update`), body, addTrackingHeader(config))
			.then(({ data }) => data)
			.catch((res: IApiErrorResponse) => handleErrorResponse(res));
	},
	get: async (hash, token) => {
		const config = addAuthorizationHeader(token);
		return await axios
			.get(buildApiEndpoint(`/customer/get?languageId=1&hash=${hash}`), addTrackingHeader(config))
			.then(({ data }) => data)
			.catch((res: IApiErrorResponse) => handleErrorResponse(res));
	},
	checkMemberNo: async (body: { memberNo?: string }, lang?: Locales): Promise<ICustomerCheckResponse> =>
		await axios
			.post(buildApiEndpoint(`/customer/checkMemberNo`), getRequestBody({ body, lang }), addTrackingHeader())
			.then(({ data }) => data)
			.catch(() => {
				redirectToErrorPage();
			}),
};
